import { tns } from "../../../node_modules/tiny-slider/src/tiny-slider";

window.addEventListener("load", () => {
    if (document.querySelectorAll(".size-options").length > 0) {
		var sizeOptions = tns({
			container: ".size-options",
			controls: true,
			nav: false,
			// items: 3,
			swipeAngle: false,
			mouseDrag: true,
			loop: false,
			fixedWidth: 88,
      // gutter: 8,
			// responsive: {
			// 	768: {
			// 		items: 2.05,
			// 	},
			// 	1024: {
			// 		items: 2.9,
			// 	},
			// 	1280: {
			// 		items: 3.03,
			// 	},
			// 	1366: {
			// 		items: 6,
			// 	},
			// },
		});
    }
    
    if (document.querySelectorAll(".model-options").length > 0) {
		var modelOptions = tns({
			container: ".model-options",
			controls: true,
			nav: false,
			// items: 3,
			swipeAngle: false,
			mouseDrag: true,
			loop: false,
			fixedWidth: 88,
      // gutter: 8,
			// responsive: {
			// 	768: {
			// 		items: 2.05,
			// 	},
			// 	1024: {
			// 		items: 2.9,
			// 	},
			// 	1280: {
			// 		items: 3.03,
			// 	},
			// 	1366: {
			// 		items: 6,
			// 	},
			// },
		});
	}
    if(document.querySelectorAll('.product-slider').length > 0){
        document.querySelectorAll('.product-slider').forEach(element => {
            let productSlider = tns({
                container: element,
                items: 1,
                slideBy: 'page',
                controls: false,
                mouseDrag: true,
                nav: true,
                navContainer: element.closest('.product-slider-container').previousElementSibling,
                navAsThumbnails: true,
            });
        });
    }

    if(document.querySelectorAll('.model-slider').length > 0){
        var modelSlider = tns({
            container: '.model-slider',
            controls: false,
            nav: false,
            autoWidth: true,
            mouseDrag: true,
            loop: false,
        });
    }

    if(document.querySelectorAll('.select-slider').length > 0){
        var selectSlider = tns({
            container: '.select-slider',
            controls: false,
            nav: false,
            autoWidth: true,
            mouseDrag: true,
            loop: false,
        });
    }

    if(document.querySelectorAll('.slider-cards-sm').length > 0){
        var sliderCardsSm = tns({
            container: '.slider-cards-sm',
            controls: true,
            nav: false,
            items: 1.02,
            swipeAngle: false,
            mouseDrag: true,
            loop: false,
            responsive: {
                768:{
                    items: 2.05,
                },
                1024:{
                    items: 2.9,
                },
                1280:{
                    items: 3.03
                },
                1366:{
                    items: 3.8
                }
            }
        });
    }

    if(document.querySelectorAll('.categories-slider').length > 0){
        var categoriesSlider = tns({
            container: '.categories-slider',
            controls: false,
            nav: false,
            items: 1.6,
            swipeAngle: false,
            mouseDrag: true,
            loop: false,
            responsive: {
                768: {
                    items: 2.2
                },
                1024: {
                    items: 2.8
                },
                1280: {
                    items: 3.2
                }, 
                1366: {
                    items: 4.2
                }
            }
        });
    }

    if(document.querySelectorAll('.category-products-slider').length > 0){
        let categoryProducts = document.querySelectorAll('.category-products-slider');
        categoryProducts.forEach((categoryProduct) => {
            let categoryProductsSlider = tns({
                container: categoryProduct,
                controls: false,
                nav: false,
                items: 1.6,
                swipeAngle: false,
                mouseDrag: true,
                loop: false,
                responsive: {
                    768: {
                        items: 3.2
                    },
                    1024: {
                        items: 4.4
                    },
                    1200: {
                        items: 4.1,
                        controls: true
                    },
                    1280: {
                        items: 5.2
                    },
                }
            });
        });
    }

    if(document.querySelectorAll('.category-title-slider').length > 0 && document.body.clientWidth >= 768){
        var categoryTitleSlider = tns({
            container: '.category-title-slider',
            controls: false,
            nav: false,
            item: 2,
            autoWidth: true,
            mouseDrag: true,
            loop: false,
            swipeAngle: false,
        });
    }

    /*if(document.querySelectorAll('.cart-more-slider').length > 0){
        window.sliderCardsSm = tns({
            container: '.cart-more-slider',
            controls: false,
            nav: false,
            autoWidth: true,
            swipeAngle: false,
            mouseDrag: true,
            loop: false,
        })
    }*/

    if(document.querySelectorAll('.blog-main-slider').length > 0){
        var sliderBlogMain= tns({
            container: '.blog-main-slider',
            controls: false,
            nav: false,
            autoWidth: true,
            swipeAngle: false,
            mouseDrag: true,
            loop: false,
            responsive: {
                1200: {
                    autoWidth: false,
                    item: 4,
                }
            }
        })
    }

    if(document.querySelectorAll('.blog-single-slider').length > 0){
        let blogSingleSlider = document.querySelectorAll('.blog-single-slider');
        blogSingleSlider.forEach((blogSingleSliderItem) => {
            var sliderBlog = tns({
                container: blogSingleSliderItem,
                controls: false,
                nav: false,
                items: 1.7,
                swipeAngle: false,
                mouseDrag: true,
                loop: false,
                responsive: {
                    1200: {
                        autoWidth: true,
                        controls: true,
                        slideBy: '.4'
                    }
                }
            })
        });
    }

    if(document.querySelectorAll('.product-grid-slider').length > 0){
        let productGridSlider = document.querySelectorAll('.product-grid-slider');
        productGridSlider.forEach((productGridSliderItem) => {
            var productGridSliderTiny = tns({
                container: productGridSliderItem,
                controls: false,
                nav: false,
                items: 1.7,
                swipeAngle: false,
                mouseDrag: true,
                loop: false,
                responsive: {
                    640: {
                        items: 2.6
                    },
                    768: {
                        items: 3.2
                    },
                    1024: {
                        items: 4.1
                    },
                    1200: {
                        autoWidth: true
                    },
                }
            })
        });
    }

    if(document.querySelectorAll('.collection-slider').length > 0){
        let collectionSlider = document.querySelectorAll('.collection-slider');
        collectionSlider.forEach((collectionSliderItem) => {
            var collectionSliderTiny = tns({
                container: collectionSliderItem,
                controls: false,
                nav: false,
                items: 1.7,
                swipeAngle: false,
                mouseDrag: true,
                loop: false,
                responsive: {
                    640: {
                        items: 2.6
                    },
                    768: {
                        items: 1.8
                    },
                    1024: {
                        items: 3.2
                    },
                    1200: {
                        items: 4,
                        autoWidth: true
                    },
                }
            })
        });
    }

    if(document.querySelectorAll('.blog-more-slider').length > 0){
        var blogMoreSlider = tns({
            container: '.blog-more-slider',
            controls: false,
            nav: false,
            items: 1.2,
            swipeAngle: false,
            mouseDrag: true,
            loop: false,
            responsive: {
                768: {
                    items: 1.7,
                },
                1200: {
                    items: 3,
                }
            }
        });
    }

    if(document.querySelectorAll('.store-slider').length > 0){
        var storeSlider = tns({
            container: '.store-slider',
            controls: false,
            nav: true,
            items: 1.1,
            swipeAngle: false,
            mouseDrag: true,
            loop: false,
            navContainer: "#store-slider-thumbnails",
            navAsThumbnails: true,
            responsive: {
                768: {
                    items: 1.8,
                },
                1200: {
                    items: 1,

                }
            }
        });
    }

    if(document.querySelectorAll('.shop-slider').length > 0){
        var shopSlider = tns({
            container: '.shop-slider',
            controls: true,
            controlsContainer: '#controls',
            prevButton: '.prev',
            nextButton: '.next',
            nav: false,
            items: 1.2,
            swipeAngle: false,
            mouseDrag: true,
            loop: false,
            responsive: {
                768: {
                    items: 2.2,
                },
                1200: {
                    items: 3,
                }
            }
        });
    }


    if(document.querySelectorAll('.store-more-slider').length > 0){
        var storeMoreSlider = tns({
            container: '.store-more-slider',
            controls: false,
            nav: false,
            items: 1.2,
            swipeAngle: false,
            mouseDrag: true,
            loop: false,
            responsive: {
                768: {
                    items: 2.2,
                },
                1200: {
                    items: 4.1,
                }
            }
        });
    }

    if(document.querySelectorAll('.review-slider').length > 0){
        var reviewSliderBlock = tns({
            container: '.review-slider',
            controls: false,
            nav: false,
            items: 1.2,
            swipeAngle: false,
            mouseDrag: true,
            loop: true,
            responsive: {
                768: {
                    items: 1.7,
                },
                1024: {
                    items: 3,
                    controls: true,
                }
            }
        });
    }

    // if(document.querySelectorAll('.grid-slider').length > 0){
    //     var forEach = function (array, callback, scope) {
    //         for (var i = 0; i < array.length; i++) {
    //             callback.call(scope, i, array[i]);
    //         }
    //     }
        
    //     var sliders = document.querySelectorAll('.grid-slider');
        
    //     var chunk = function ( array, size ) {
    //         let arr = [];
    //         for ( let i = 0; i < array.length; i += size ) {
    //             let newSlicedArray = Array.prototype.slice.call( array, i, i + size );
    //             arr.push(newSlicedArray);
    //         }
    //         return arr;
    //     }
        
    //     forEach(sliders, function (index, value) {
    //         let childrens = value.querySelectorAll(".grid-slider-item");
    //         let chunkSize = value.dataset.chunksize;
    //         let final = chunk( childrens, parseInt(chunkSize) );


    //         let newHTML = final.map( towrap => towrap.reduce( (acc, el) => (acc.appendChild(el),acc) , document.createElement('div') ) ).forEach( el => {
    //             el.className ="grid-slider-item-column";
    //             value.appendChild(el);
    //         })
         
    //         let slider = tns({
    //             container: value,
    //             items: 1,
    //             autoWidth: true,
    //             slideBy: "page",
    //             loop: true,
    //             gutter: 0,
    //             mouseDrag: true,
    //             controls: false,
    //             nav: false,
    //             loop: false,
    //             responsive: {
    //                 820: {
    //                     items: 4,
    //                     autoWidth: false,
    //                 }
    //             }
    //         });
        
    //     });
    // }
    
}, false);
    

